<template>
  <div>
    <Breadcrumbs :title="title"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="$router.push({ path: '/stock/board/main' })">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>MAIN</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='main').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='main' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='main' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='main' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='main').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="$router.push({ path: '/stock/board/ace' })">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>ACE</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='ace').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='ace').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="$router.push({ path: '/stock/board/leap' })">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>LEAP</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='leap').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase mt-4">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='leap').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>

              <div class="col-sm-12 mb-3">
                <b-button v-if="stock" id="default-lg-primary" variant="primary" class="btn-pill btn-air-primary" size="lg" @click="$router.push('/stock/ticker/'+stock.name)">View {{ stock.name }} Historical</b-button>
                <b-button v-if="stock" id="default-lg-primary" variant="primary" class="btn-pill btn-air-primary ml-3" size="lg" @click="$router.push('/stock/ticker/'+stock.name+'/date')">View {{ stock.name }} Intraday</b-button>
              </div>

              <highcharts v-if="stock" class="chartWrapper" :constructor-type="'stockChart'" :options="chartOptions"></highcharts>

              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                    selectable
                    show-empty
                    stacked="md"
                    select-mode="single"
                    selectedVariant="success"
                    :items="stocks"
                    :fields="tablefields"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                    @row-selected="stockSelected"
                >
                </b-table>
              </div>
              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      board: this.$route.params.board,
      tablefields: [
        { key: 'id', label: 'ID', sortable: true, },
        { key: 'name', label: 'Name', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'open', label: 'Open', sortable: true, },
        { key: 'high', label: 'High', sortable: true, },
        { key: 'low', label: 'Low', sortable: true, },
        { key: 'close', label: 'Close', sortable: true, },
        { key: 'change_pct', label: 'Change %', sortable: true, },
        { key: 'volatility_pct', label: 'Volatile %', sortable: true, },
        { key: 'volume', label: 'Volume', sortable: true, },
        { key: 'market_cap', label: 'Market Cap', sortable: true, },
      ],
      stocks: [],
      stock: null,

      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 100, 1000],
      chartOptions: {
        chart: {
          zoomType: 'x',
          height: 600,
          responsive: true,
          maintainAspectRatio: false
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        yAxis: [{
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'OHLC'
          },
          height: '60%',
          lineWidth: 2,
          resize: {
            enabled: true
          }
        }, {
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'Volume'
          },
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 2
        }],
        tooltip: {
          split: true
        },
        credits: { enabled: false },
        xAxis: [{
          tickLength: 0,
          lineWidth: 1,
          labels: {
            enabled: false
          },
        }],
        series: [{
          type: 'column',
          name: 'Volume',
          data: [],
          yAxis: 1
        }, {
          type: 'candlestick',
          name: '',
          id: '',
          data: []
        }]
      },
    }
  },
  computed: {
    title: function () { return this.board.toUpperCase() + ' Board' },
    sortOptions() {
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
    }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } },
    '$route.params.board': function (val) { this.board = val; this.fetchBoard() }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchBoard()
    },
    fetchBoard() {
      this.$http.get('/api/stock/board/'+this.board)
          .then(({data}) => {
            this.stocks = data.stocks.filter(s => s.category === 'stock').map(s => ({ ...s, change_pct:Math.round((s.i_close/s.open-1)*1000)/10, volatility_pct:Math.round((s.high/s.low-1)*1000)/10 }))
            this.totalRows = this.stocks.length
          })
          .catch(e => console.log(e.message))
    },
    fetchData() {
      this.$http.get('/api/stock/intraday/'+this.stock.name+'/'+this.date)
          .then(({data}) => {
            this.ohlc = data.data.map(d => ([d[0], d[1], d[2], d[3], d[4]]))
            this.vol = data.data.map(d => ([d[0], d[5]]))
            this.chartOptions.series[1].name = this.stock.name
            this.chartOptions.series[1].id = this.stock.id
            this.chartOptions.series[1].data = this.ohlc
            this.chartOptions.series[0].data = this.vol
            this.chartOptions.yAxis[0].plotLines = [
              {
                color: 'orange',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].close,
                label: {
                  text: 'Yesterday Close : '+data.historical[1].close,
                  align: 'center'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'blue',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].high,
                label: {
                  text: 'Yesterday High : '+data.historical[1].high,
                  align: 'right'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'red',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].low,
                label: {
                  text: 'Yesterday Low : '+data.historical[1].low,
                  align: 'right'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'blue',
                dashStyle: 'dash',
                width: 2,
                value: Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high)),
                label: {
                  text: 'Week High : '+Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high)),
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'red',
                dashStyle: 'dash',
                width: 2,
                value: Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low)),
                label: {
                  text: 'Week Low : '+Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low)),
                },
                style: {
                  fontWeight: 'bolder'
                }
              }
            ]
            this.chartOptions.title.text = this.stock.id+' '+this.stock.name+' - '+this.stock.company
            this.chartOptions.subtitle.text = data.historical[0].close+' - [Week:'+Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low))+'~'+Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high))+']'
            this.chartOptions = { ...this.chartOptions }
            this.date = data.filter.to
          })
          .catch(e => console.log(e.message))
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    stockSelected(item) {
      this.stock = item[0]
      this.fetchData()
    },
  }
}
</script>